import { useProductSummaryName } from '../hooks/useProductSummaryName';

const ProductBrand = () => {
	const {
		blockClass,
		showFieldsProps: { showBrandName },
		mzProductName,
	} = useProductSummaryName();

	return (
		<span
			className={`productBrand productBrand--${blockClass} brandName--${blockClass} vtex-product-summary-2-x-productBrand vtex-product-summary-2-x-productBrand--${blockClass} vtex-product-summary-2-x-brandName vtex-product-summary-2-x-brandName--${blockClass} t-body`}
		>
			{mzProductName ? mzProductName : 'Calça selva noturna roupa de inverno'}
			{showBrandName && ' - Nike'}
		</span>
	);
};

export default ProductBrand;
